import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';

import { store } from '@/store/index';
import { dispatchPasswordRecovery } from '@/store/main/actionsMain';
import BaseButtonSubmit from '@/views/base/BaseButtonSubmit.vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import PasswordRecoveryForm from '@/views/pages/passwordRecovery/PasswordRecoveryForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordRecoveryPage',
  setup(__props) {

const m = defineMessages({
  passwordRecoveryTitle: 'パスワード再発行',
});

const isValidForm = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const email = ref<string>('');

const submit = async (): Promise<void> => {
  try {
    isLoading.value = true;

    const data = { username: email.value };

    await dispatchPasswordRecovery(store, data);
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,m, isValidForm, isLoading, email, submit, sharedMessages, BaseButtonSubmit, BaseFormCard, PasswordRecoveryForm }
}

})